import { Toaster } from "components/notification/Toaster";
import { useDispatch } from "react-redux";
import usePromiseInstance_authorization from "./config";
import { func_serviceHandling, func_validation, isNotNullUndefined, isStringNotEmpty } from "functions";
import { 
    getRevRecPlanList_request,
    getRevRecPlanList_success,
    getRevRecPlanList_failure,
    getPlanByComId_request,
	getPlanByComId_success,
	getPlanByComId_failure,
	updatePlan_request,
	updatePlan_success,
	updatePlan_failure,
    syncDownDebitNotes_request,
	syncDownDebitNotes_success,
	syncDownDebitNotes_failure,
	switchCommitmentPlan_request,
	switchCommitmentPlan_success,
	switchCommitmentPlan_failure
 } from "../slices/commitmentPaySetup.slices";

export default function useCommitmentPaySetup() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getRevRecPlanList(pageNo, pageSize, sort, filterOptions = {}) {

        // get status from filter options
        let { status, ...otherFilterOptions } = filterOptions

        let paramObj = {
			pageIndex: pageNo + 1,
			pageSize: pageSize,
			...otherFilterOptions,
            ...(isNotNullUndefined(status) && isStringNotEmpty(status))? {
                status: (status === "Completed")? "Yes":"No"
            }:{},
		}

        let url = func_serviceHandling.createUrlWithParams('/Invoice/GetAllRevenueRecognitionPlan', paramObj)

        dispatch(getRevRecPlanList_request());

        request(getRevRecPlanList_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getRevRecPlanList_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load Revenue Recognition Plan(s)";
					Toaster({ type: "error", msg });

                    dispatch(getRevRecPlanList_failure(msg));
                })
        })
    }

    function getPlanByComId(paramObj) {

        let url = func_serviceHandling.createUrlWithParams('/Invoice/GetRevenueRecognitionPlan_ComInfo', paramObj)

        dispatch(getPlanByComId_request());

        request(getPlanByComId_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getPlanByComId_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load Revenue Recognition Plan(s)";
					Toaster({ type: "error", msg });

                    dispatch(getPlanByComId_failure(msg));
                })
        })
    }

    function updatePlan(paramObj) {

        dispatch(updatePlan_request());

        request(updatePlan_request, (axios) => {    
            axios.post('/Invoice/UpdateNetsuiteRevRecPlan', paramObj)
                .then((response) => {
                    dispatch(updatePlan_success(response.data));
                    let msg = response?.data?.message;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Record updated successfully" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load Revenue Recognition Plan(s)";
					Toaster({ type: "error", msg });

                    dispatch(updatePlan_failure(msg));
                })
        })
    }

    function syncDownDebitNotes(paramObj) {

        let url = func_serviceHandling.createUrlWithParams('/Invoice/FetchCommitmentPlan_GenerateDebitNote', paramObj)

        dispatch(syncDownDebitNotes_request());

        request(syncDownDebitNotes_request, (axios) => {    
            axios.post(url)
                .then((response) => {
                    dispatch(syncDownDebitNotes_success(response.data));
                    let msg = response?.data;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Sync down debit notes successfully" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to sync down debit notes";
					Toaster({ type: "error", msg });

                    dispatch(syncDownDebitNotes_failure(msg));
                })
        })
    }

    function switchCommitmentPlan() {

        dispatch(switchCommitmentPlan_request());

        request(switchCommitmentPlan_request, (axios) => {    
            axios.post('/Invoice/AddCommitmentFlag_UnbindPlan')
                .then((response) => {
                    dispatch(switchCommitmentPlan_success(response.data));
                    let msg = response?.data;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Switch to commitment plan successfully" });
                })
                .catch((error) => {
                    let msg = error?.response?.data? error.response.data: "Failed to switch to commitment plan";
					Toaster({ type: "error", msg });

                    dispatch(switchCommitmentPlan_failure(msg));
                })
        })
    }

    return {
        getRevRecPlanList,
        getPlanByComId,
        updatePlan,
        syncDownDebitNotes,
        switchCommitmentPlan
    }
}